import React from "react";
import { useI18n } from "../providers/I18nProvider";
import "../styles/ListToolbar.css";

// Tüm liste sayfalarında ortak düzen: sekmeler (sayaçlı) + filtre çubuğu + boş durum.
//   <TabBar tabs={[{ key, label, count, attention }]} value={tab} onChange={setTab} />
//   <FilterBar onReset={...} showReset={bool}> <SearchInput .../> <select className="lt-input"/> </FilterBar>

export const TabBar = ({ tabs, value, onChange, ariaLabel }) => (
  <div className="leaves-tabs lt-tabs" role="tablist" aria-label={ariaLabel}>
    {tabs.map((tb) => (
      <button
        key={tb.key}
        type="button"
        role="tab"
        aria-selected={value === tb.key}
        className={`leaves-tab${value === tb.key ? " active" : ""}${
          tb.attention && tb.count > 0 ? " attention" : ""
        }`}
        onClick={() => onChange(tb.key)}
      >
        {tb.label}
        {tb.count != null && <span className="leaves-tab-count">{tb.count}</span>}
      </button>
    ))}
  </div>
);

export const SearchInput = ({ value, onChange, placeholder }) => (
  <input
    type="search"
    className="leaves-filter-input lt-input lt-search"
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);

// Etiketli alan (tarih, select vb. için)
export const FilterField = ({ label, children }) => (
  <label className="leaves-filter-date lt-field">
    <span>{label}</span>
    {children}
  </label>
);

export const FilterBar = ({ children, showReset, onReset }) => {
  const { t } = useI18n();
  return (
    <div className="leaves-toolbar lt-toolbar">
      {children}
      {showReset && (
        <button type="button" className="btn lt-reset" onClick={onReset}>
          {t("common.resetFilters")}
        </button>
      )}
    </div>
  );
};

export const EmptyState = ({ message, action }) => (
  <div className="lt-empty">
    <p>{message}</p>
    {action}
  </div>
);

// Sayaç yardımcısı: { key: predicate } -> { key: count }
export const countBy = (items, predicates) =>
  Object.fromEntries(
    Object.entries(predicates).map(([key, fn]) => [key, items.filter(fn).length])
  );
